import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { addLeadStatus } from "../../services/leadService";
import "./LeadStatus.css";

const AddLeadStatusModal = ({ onClose, onSuccess }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      toast.error("Status name is required");
      return;
    }

    setLoading(true);

    const res = await addLeadStatus({
      name: name.trim(),
      is_active: 1,     // backend default
      sort_order: 1,    // backend default
    });

    setLoading(false);

    if (res.status === "success") {
      toast.success("Status added successfully");
      onSuccess();
      onClose();
    } else {
      toast.error(res.message || "Failed to add status");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">

        {/* HEADER */}
        <div className="modal-header">
          <h4>Add Lead Status</h4>
          <button className="close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* FORM */}
        <form className="modal-body" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Status Name *</label>
            <input
              type="text"
              placeholder="Enter status name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              autoFocus
            />
          </div>

          <button
            type="submit"
            className="btn-primary full-width"
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Status"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddLeadStatusModal;
